import { IDB_ARCHIVED_INQUIRY_LIST_STORE, IDB_INQUIRY_LIST_KEYPATH, IDB_INQUIRY_LIST_STORE, InquiryViewColumns, TRMAccountMetadataListSelectColumns, TRMAccTaxExemptionListColumns, TRMSubClientTaxExemptionListColumns, TRMExportInquiryColumns, TRMSubClientSettingMetadataListColumns, TRMTemplateFolderPath } from "../../../shared/constants/globalConstants"
import { AnewTRMFolderPath, ListNames } from "../../../shared/constants/globalConstants"
import { anewRListsHttp } from "../../../shared/services/api/anew-r-lists-http"
import { listAttachments} from "../../../shared/utils/fileHelpers"
import { anewRViewsHttp } from "../../../shared/services/api/anew-views-http"
import { clearStore, dbStore, deleteItemsInStore,  getAllItemsInStore, getLatestModifiedDate, saveItems } from "../../../store/indexed-db/indexedDBHelper"
import { isProcessorDisabled, V_TRMInquiryHistoryListColoums } from "../../../Configuration"

const listName=ListNames.InquiryList
const viewName=ListNames.V_TRAMInquiryList;
const viewNameForExport=ListNames.V_ExportCSV_TRMInquiryList;
const vehicleInformationListName=ListNames.TRMVehicleInformationList
const accountInformationListName=ListNames.TRMAccountSettingMetadataList
const subClientMetadataListName=ListNames.TRMSubClientSettingMetadataList
const subClientTaxExemptionListName=ListNames.TRMSubClientTaxExemptionList
const accountTaxExemptionListName=ListNames.TRMAccTaxExemptionList
const bulkTemplateListName=ListNames.TRMBulkImportTemplateList
const exportColumnConfigurationListName = process.env.REACT_APP_EXPORT_COLUMN_CONFIG_LIST || "ExportColumnConfigurationList"
const userPreferenceListName = process.env.REACT_APP_USER_PREFERENCE_LIST || "UserPreferenceList"

const safeFilterValue = (value: string) => String(value ?? '').replace(/'/g, "''")
export const buildGlobalSearchFilter = (value: string) => {
  const escapedSearch = safeFilterValue(value);
  const formattedId = String(escapedSearch).padStart(6, '0');
  const intMaxValue = 2147483647;

  const isNumeric = /^\d+$/.test(escapedSearch);
  const isValidId = isNumeric && Number(escapedSearch) <= intMaxValue;

  const filters = [
    isValidId ? `_Id eq ${Number(formattedId)}` : null,
    `contains(${InquiryViewColumns.VINNumber}, '${escapedSearch}')`,
    `contains(${InquiryViewColumns.TMSID}, '${escapedSearch}')`,
  ].filter(Boolean);

  return filters.join(' or ');
};

const getPreferenceStorageKey = (userId: string, source: string) => `trm-user-preference-${source}-${userId}`
const getConfigurationStorageKey = (source: string) => `trm-export-config-${source}`

// Inquiries, Work Orders, and the Dashboard widgets all sync the same IndexedDB store
// (IDB_INQUIRY_LIST_STORE) independently on mount. Without coordination, navigating away
// mid-sync leaves that sync's batch fetch and IndexedDB writes running in the background,
// where they contend for the same IndexedDB readwrite transaction as whichever page the user
// navigated to next (and keep issuing large batched requests the target page no longer needs).
// This tracks the most recently started sync per store so an outdated one can stop issuing
// further batches and skip writing once a newer sync for the same store has begun.
const activeSyncSession: Record<string, number> = {}

const beginSyncSession = (storeName: string): number => {
  const session = (activeSyncSession[storeName] ?? 0) + 1
  activeSyncSession[storeName] = session
  return session
}

const isSyncSessionCurrent = (storeName: string, session: number): boolean =>
  activeSyncSession[storeName] === session

const MAX_SYNC_CONTINUATIONS = 3

type ExportColumnConfig = {
  tableName: string
  fieldName: string
  displayName: string
  IsSelected?: boolean
}

export const postItemToInquiryList = async(inquirieItem:any) =>{
    const inquiryList = await anewRListsHttp().getList(listName)
    const inquiryListItem=inquiryList.addOrUpdateItem({...inquirieItem})
    return inquiryListItem 
}
export const postBulkItemToTemplateList = async(item: any) => {
    const list = await anewRListsHttp().getList(bulkTemplateListName)
    const listItem = await list.addOrUpdateItem(item)
    return listItem
}
export const updateItemToInquiryList = async(inquirieItem:any,eKey:String,eTag:String) =>{
  try{
    const inquiryList = await anewRListsHttp().getList(listName)
    const inquiryListItem=await inquiryList.addOrUpdateItem({...inquirieItem,eKey:eKey,eTag:eTag})
    return { success: true, data: inquiryListItem }; 
  }catch(error : any){
    return { success: false, error: error };
  }
}

export const addOrUpdateToList = async(listName:string,item:any) =>{
try{
    const list = await anewRListsHttp().getList(listName)
    const listItem=await list.addOrUpdateItem(item)
    return { success: true, data: listItem }; 
  }catch(error : any){
    return { success: false, error: error };  
  }
};
export const updateAccInfo = async(inquirieItem:any,eKey:String,eTag:String) =>{
  try{
    const inquiryList = await anewRListsHttp().getList(accountInformationListName)
    const inquiryListItem=await inquiryList.addOrUpdateItem({...inquirieItem,eKey:eKey,eTag:eTag})
    return { success: true, data: inquiryListItem }; 
  }catch(error : any){
    return { success: false, error: error };
  }
}
export const updateAccTax= async(inquirieItem:any,eKey:String,eTag:String) =>{
  try{
    const inquiryList = await anewRListsHttp().getList(accountTaxExemptionListName)
    const inquiryListItem=await inquiryList.addOrUpdateItem({...inquirieItem,eKey:eKey,eTag:eTag})
    return { success: true, data: inquiryListItem };
   }catch(error : any){
    return { success: false, error: error };
  }
}


export const updateSubClientInfo = async(inquirieItem:any,eKey:String,eTag:String) =>{
  try{
    const inquiryList = await anewRListsHttp().getList(subClientMetadataListName)
    const inquiryListItem=await inquiryList.addOrUpdateItem({...inquirieItem,eKey:eKey,eTag:eTag})
    return { success: true, data: inquiryListItem }; 
  }catch(error : any){
    return { success: false, error: error };
  }
}

export const updateSubClientTax = async(inquirieItem:any,eKey:String,eTag:String) =>{
  try{
    const inquiryList = await anewRListsHttp().getList(ListNames.TRMSubClientTaxExemptionList)
    const inquiryListItem=await inquiryList.addOrUpdateItem({...inquirieItem,eKey:eKey,eTag:eTag})
    return { success: true, data: inquiryListItem };
  }catch(error : any){
    return { success: false, error: error };
  }
}

export const postItemToVehicleInformationList = async(inquirieItem:any) =>{
    const vehicleInformationList = await anewRListsHttp().getList(vehicleInformationListName)

    const vehicleInformationListItem= await vehicleInformationList.addOrUpdateItem({...inquirieItem})
    return vehicleInformationListItem 
}
export const PostAccountInformationList = async (accountInformationItem: any) => {
  try {
    const accountInformation = await anewRListsHttp().getList(accountInformationListName);
    const accountInformationListItem = await accountInformation.addOrUpdateItem({
      ...accountInformationItem,
    });
    return accountInformationListItem;
  } catch (error) {
    console.error("Error while adding/updating Account Information:", error);
    throw error; 
  }
};
export const PostAccountTaxExemptionList = async (accountTaxExemptionItem: any) => {
  try {
    const accountTaxExemption = await anewRListsHttp().getList(accountTaxExemptionListName);
    const accountTaxExemptionListItem = await accountTaxExemption.addOrUpdateItem({
      ...accountTaxExemptionItem,
    });
    return accountTaxExemptionListItem;
  } catch (error) {
    console.error("Error while adding/updating Account Tax Exemption Information:", error);
    throw error;
  }
};

export const PostSubClientInformationList = async (subClientItem: any) => {
  try {
    const subClientInformation = await anewRListsHttp().getList(subClientMetadataListName);
    const subClientInformationListItem = await subClientInformation.addOrUpdateItem({
      ...subClientItem,
    });
    return subClientInformationListItem;
  } catch (error) {
    console.error("Error while adding/updating SubClient Information:", error);
    throw error; 
  }
};
export const PostSubClientTaxExemptionList = async (subClientItem: any) => {

  try {
    const subClientTaxExemptionInformation = await anewRListsHttp().getList(subClientTaxExemptionListName);
    const subClientTaxExemptionInformationListItem = await subClientTaxExemptionInformation.addOrUpdateItem({
      ...subClientItem,
    });
    return subClientTaxExemptionInformationListItem;
  } catch (error) {
    console.error("Error while adding/updating SubClient Tax Exemption Information:", error);
    throw error;
  }
};

export const getVehicleInformationByVIN = async(id:any) =>{
    const vehicleInformationList = await anewRListsHttp().getList(ListNames.TRMVehicleInformationList)
    const vehicleInformationListItem=await vehicleInformationList.query().filter(`InquiryGUID eq '${safeFilterValue(id)}'`).orderBy([{ orderBy: 'ItemModified', ascending: false }]).get()
    const itemsArray = Array.from(vehicleInformationListItem as Iterable<any>);
    return itemsArray[0]  as any;
}

export const getInquiryByVINAndProcessType = async (vin: string, processType?: string) => {
  const list = await anewRViewsHttp().getview(viewName)
  const vinFilter = `VINNumber eq '${safeFilterValue(vin)}'`
  const processTypeFilter = processType?.trim()
    ? ` and ProcessType eq '${safeFilterValue(processType)}'`
    : ''
  const filterQuery = `${vinFilter}${processTypeFilter } and IsDeleted eq false and IsArchived eq false and StatusCode ne 3 and StatusCode ne 7 and StatusCode ne 17`

  const countResult = [
    ...(await list
      .query()
      .filter(filterQuery)
      .select(InquiryViewColumns.InquiryGUID)
      .count(InquiryViewColumns.InquiryGUID)
      .get())
  ][0] as { InquiryGUID_count: number }

  if (!countResult?.InquiryGUID_count) {
    return undefined
  }

  const pageSize = 5000
  const totalCount = countResult.InquiryGUID_count
  let fetchedCount = 0
  let batchIndex = 0
  let allItems: any[] = []

  while (fetchedCount < totalCount) {
    const items = await list
      .query()
      .filter(filterQuery)
      .select(
        InquiryViewColumns.InquiryGUID,
        InquiryViewColumns.StatusCode,
        InquiryViewColumns.ProcessType,
        InquiryViewColumns.VINNumber,
      )
      .orderBy([{ orderBy: 'ItemModified', ascending: false }])
      .top(pageSize)
      .skip(batchIndex * pageSize)
      .get()

    const itemsArray = Array.from(items as Iterable<any>)
    allItems = [...allItems, ...itemsArray]
    fetchedCount += itemsArray.length
    batchIndex++

    if (itemsArray.length === 0) {
      break
    }
  }

  return allItems[0] as any
}

export const updateItemToVehicleInformationList = async(inquirieItem:any,eKey:String,eTag:String) =>{
    const vehicleInformationList = await anewRListsHttp().getList(vehicleInformationListName)
    const vehicleInformationListItem=await vehicleInformationList.addOrUpdateItem({...inquirieItem,eKey:eKey,eTag:eTag})
    return vehicleInformationListItem
}


export const getInquiryTotalCount = async (filterQuery: string='', useDistinct: boolean = false) => {
  try {
    const list = await anewRViewsHttp().getview(viewName);
    // Callers that compare this count against the synced IndexedDB store must pass useDistinct:
    // the store holds one row per inquiry, while the view's vehicle join can return several.
    let countQuery = list
      .query().filter(filterQuery)
      .select('InquiryGUID')
      .count('InquiryGUID');
    if (useDistinct) {
      countQuery = countQuery.distinct(true);
    }
    const countResult = await countQuery.get();

    const countArray = Array.from(countResult as Iterable<any>);
    const totalCount = countArray[0]?.InquiryGUID_count || 0;
    return totalCount;
  } catch (error) {
    console.error('Error fetching initial inquiry data:', error);
    throw error;
  }
};
/**
 * Fetches all Saved Inquiries for the current user and enriches each inquiry
 * with its corresponding Vehicle Information from the Vehicle Information list.**/
export const savedInquires = async (filterQuery: string) => {
  try {
    // Get Saved Inquiries
    const inquiryList = await anewRListsHttp().getList(
      ListNames.InquiryList
    );
    const inquiryItems = await inquiryList
      .query()
      .filter(filterQuery)
      .get();
      const inquiries = Array.from(
      inquiryItems as Iterable<any>
    );
    if (!inquiries.length) {
      return [];
    }// Collect unique Inquiry GUIDs
    const inquiryGUIDs = [
      ...new Set(
        inquiries
          .map((item: any) => item.InquiryGUID)
          .filter(Boolean)
      ),
    ];
     // Get Vehicle Information
    const vehicleList = await anewRListsHttp().getList(
      ListNames.TRMVehicleInformationList
    );

    const vehicleFilter = inquiryGUIDs
      .map((inquiryGUID) => `InquiryGUID eq '${inquiryGUID}'`)
      .join(' or ');

    const vehicleItems = inquiryGUIDs.length
      ? await vehicleList
          .query()
          .filter(vehicleFilter)
          .get()
      : [];

    const vehicles = Array.from(
      vehicleItems as Iterable<any>
    );

    // Create InquiryGUID → Vehicle Map
    const vehicleMap = new Map(
      vehicles.map((vehicle: any) => [
        vehicle.InquiryGUID,
        vehicle,
      ])
    ); // Merge Vehicle Information
   const result = inquiries.map((item: any) => ({
  ...item,
  'Status/StatusTitle':
    item['Status/StatusTitle'] ??
    (Number(item.StatusCode) === 0 ? 'Saved' : ''),
  VehicleInformation:
    vehicleMap.get(item.InquiryGUID) ?? null
}));

return result;
  } catch (error) {
    console.error(
      "Error fetching saved inquiries:",
      error
    );
    throw error;
  }
};
export const getSavedInquiryCount = async (
  filterQuery: string = ''
) => {
  try {
    const list = await anewRListsHttp().getList(ListNames.InquiryList);

    const countResult = await list
      .query()
      .filter(filterQuery)
      .select('InquiryGUID')
      .count('InquiryGUID')
      .get();

    const countArray = Array.from(countResult as Iterable<any>);
    const totalCount = countArray[0]?.InquiryGUID_count || 0;

    return totalCount;
  } catch (error) {
    console.error('Error fetching saved inquiry count:', error);
    throw error;
  }
};
export const buildRoleFilter = (me: any, userRoles: any, Type?: string) => {
  const userId = me?.userId;
  let roleFilter = "";

  if (!userRoles.isTRMAdmin) {
    if (userRoles.isTRMInbound || userRoles.isTRMOutbound) {
      const territoryFilters = userRoles.territories
        .map((t: string) => `Territory eq '${t}'`)
        .join(" or ");

      roleFilter = `${territoryFilters} or ItemCreatedBy eq '${userId}' or AnewAccOwnerID eq '${userId}'`;
    } if (userRoles.isTRMSales) {
      roleFilter =  roleFilter !== "" ? `${roleFilter} or ItemCreatedBy eq '${userId}' or AnewAccOwnerID eq '${userId}'` : `ItemCreatedBy eq '${userId}' or AnewAccOwnerID eq '${userId}'`;
    } if (userRoles?.isTRMProcessor && !isProcessorDisabled) {
      roleFilter = roleFilter !== "" ? `${roleFilter} or AssignedProcessor eq '${userId}'` : `AssignedProcessor eq '${userId}'`;
    } if ((userRoles?.isCustomer || isProcessorDisabled) && roleFilter === "") {
      roleFilter = `ItemCreatedBy eq '${userId}'`;
    }
     roleFilter =
      roleFilter !== ""
        ? `${roleFilter} or TeamMembers eq '${userId}'`
        : `TeamMembers eq '${userId}'`;
  
  }
  const returnStatement = roleFilter !== "" ? `(${roleFilter}) and IsDeleted eq false` : 'IsDeleted eq false';
  return Type === 'FeeExport' ?
                      roleFilter !== "" ? `(${roleFilter}) and IsArchived eq false` : 'IsArchived eq false'
                  : Type === 'Export' || Type === 'Active' ? `(${returnStatement}) and IsArchived eq false` : returnStatement;
};

export const buildGlobalSearchRoleFilter = (value: string, me: any, userRoles: any) =>
  `(${buildRoleFilter(me, userRoles)}) and (${buildGlobalSearchFilter(value)})`;

export const getUniqueFilterValues = async (filterQuery: string,selectedFilter?: string) => { 
  let uniqueValues:any = {}
  const list = await anewRViewsHttp().getview(viewName);
    if(!selectedFilter){
     const uniqueProcessTypeResult =await list.query().filter(filterQuery).select(InquiryViewColumns.ProcessType).distinct(true).get()
      const uniqueProcessType = [...uniqueProcessTypeResult].reduce((acc, curr:any) => {
      if (curr.ProcessType) {
        acc.push(curr.ProcessType);
      }
      return acc;
    }, [] as string[]);
    uniqueValues.ProcessType=uniqueProcessType
    }
    if(!selectedFilter || ['ProcessType'].includes(selectedFilter)){
      const uniqueAccNameResult = await list.query().filter(filterQuery).select(InquiryViewColumns.AccName).distinct(true).get()
       const uniqueAccName = [...uniqueAccNameResult].reduce((acc, curr:any) => {
      if (curr.AccName) {
        acc.push(curr.AccName);
      }
      return acc;
    }, [] as string[]);
    uniqueValues.AccName=uniqueAccName
    }
    if(!selectedFilter || ['AccName','ProcessType'].includes(selectedFilter)){
      const uniqueSubClientNameResult = await list.query().filter(filterQuery).select(InquiryViewColumns.SubClientName).distinct(true).get()
       const uniqueSubClientName = [...uniqueSubClientNameResult].reduce((acc, curr:any) => {
      if (curr.SubClientName) {
        acc.push(curr.SubClientName);
      }
      return acc;
    }, [] as string[]);
      uniqueValues.SubClientName=uniqueSubClientName
    }
    if(!selectedFilter || ['SubClientName','AccName','ProcessType'].includes(selectedFilter)){
     const uniqueStateResult=await list.query().filter(filterQuery).select(InquiryViewColumns.State).distinct(true).get()
       const uniqueState = [...uniqueStateResult].reduce((acc, curr:any) => {
      if (curr.State) { 
        acc.push(curr.State);
      }
      return acc;
    }, [] as string[]);
      uniqueValues.State=uniqueState
    }
    if(!selectedFilter || ['RegState','SubClientName','AccName','ProcessType'].includes(selectedFilter) ){
     const uniqueCountyResult=await list.query().filter(filterQuery).select(InquiryViewColumns.County).distinct(true).get()
       const uniqueCounty = [...uniqueCountyResult].reduce((acc, curr:any) => {
      if (curr.County) {
        acc.push(curr.County);
      }
      return acc;
    },[] as string[]);
    uniqueValues.County=uniqueCounty
    }
    if( !selectedFilter || ['RegCounty','RegState','SubClientName','AccName','ProcessType'].includes(selectedFilter)  ){
      const uniqueAssignedProcessorResult= await list.query().filter(filterQuery).select(InquiryViewColumns.AssignedProcessor).distinct(true).get()
      const uniqueAssignedProcessor = [...uniqueAssignedProcessorResult].reduce((acc, curr:any) => {
      if (curr.AssignedProcessor) {
        acc.push({label: curr.AssignedProcessor.properties.defaultDisplay, value: curr.AssignedProcessor.userID});
      }
      return acc;
    }, [] as {label: string, value: string}[]);
    uniqueValues.AssignedProcessors=uniqueAssignedProcessor
    }
    return uniqueValues
}



export const getUniqueFilters = async (filterQuery: string, useDistinct: boolean = true) => {
  try {
    const list = await anewRListsHttp().getList(listName);
      let queryBuilder = list
      .query()
      .filter(filterQuery)
      .expand('Status')
      .select(
        'ProcessType',
        'AccName',
        'SubClientName',
        'RegState',
        'RegCounty',
        'ItemCreated',
        'Status/StatusTitle'
      );

    if (useDistinct) {
      queryBuilder = queryBuilder.distinct(true); 
    }

    const items = await queryBuilder.get();
    return items;

  } catch (error) {
    console.error('Error fetching filter data:', error);
    throw error;
  }
};

export const getGlobalSearchCount = async (filterQuery: string, me: any, userRoles: any) =>{
const Data = await anewRListsHttp().getList(listName);
const countResult = [...(await Data.query()
  .filter(buildGlobalSearchRoleFilter(filterQuery, me, userRoles))
  .select(InquiryViewColumns.InquiryGUID).count(InquiryViewColumns.InquiryGUID).get())][0] as {InquiryGUID_count:number};
return countResult?.InquiryGUID_count || 0;
}

export const getGlobalSearchSectionCounts = async (query: string, me: any, userRoles: any) => {
  try {
    const baseFilter = `(${buildGlobalSearchRoleFilter(query, me, userRoles)})`;
    const list = await anewRListsHttp().getList(listName);

    const makeCount = async (filter: string) => {
      const countResult = [...(await list.query().filter(filter).select(InquiryViewColumns.InquiryGUID).count(InquiryViewColumns.InquiryGUID).get())][0] as {InquiryGUID_count:number};
      return countResult?.InquiryGUID_count || 0;
    }

    const inquiriesFilter = `${baseFilter} and IsArchived eq false and IsWorkOrder eq false and StatusCode ne 0`
    const workOrdersFilter = `${baseFilter} and IsArchived eq false and IsWorkOrder eq true`
    const archivedFilter = `${baseFilter} and IsArchived eq true`
    // const savedFilter = `${baseFilter} and IsArchived eq false and StatusCode eq 0`

    const [inquiries, workOrders, archived] = await Promise.all([
      makeCount(inquiriesFilter),
      makeCount(workOrdersFilter),
      makeCount(archivedFilter),
      // makeCount(savedFilter),
    ])

    return {
      Inquiries: inquiries,
      'Work Orders': workOrders,
      Archived: archived,
      // Saved: saved,
    }
  } catch (error) {
    console.error('Error fetching global search section counts', error)
    return { Inquiries: 0, 'Work Orders': 0, Archived: 0 }
  }
}

export type GlobalSearchHeaderSection = {
  title: 'Inquiries' | 'Work Orders' | 'Archived' | 'Saved'
  count: number
  items: any[]
}

const buildGlobalSearchHeaderSections = (items: any[]): GlobalSearchHeaderSection[] => {
  const inquiries = items.filter((item: any) => !item?.IsArchived && !item?.IsWorkOrder && Number(item?.StatusCode) !== 0)
  const workOrders = items.filter((item: any) => !item?.IsArchived && item?.IsWorkOrder)
  const archived = items.filter((item: any) => item?.IsArchived)
  // const saved = items.filter((item: any) => !item?.IsArchived && Number(item?.StatusCode) === 0)

  const sections: GlobalSearchHeaderSection[] = [
    { title: 'Inquiries', count: inquiries.length, items: inquiries.slice(0, 2) },
    { title: 'Work Orders', count: workOrders.length, items: workOrders.slice(0, 2) },
    { title: 'Archived', count: archived.length, items: archived.slice(0, 2) },
    // { title: 'Saved', count: saved.length, items: saved.slice(0, 2) },
  ]

  return sections.filter((section) => section.count > 0)
}

export const fetchTopThree = async (query: string, me: any, userRoles: any) => {
  try {
    const list = await anewRListsHttp().getList(listName);

    const items = await list
      .query()
      .filter(buildGlobalSearchRoleFilter(query, me, userRoles))
      .orderBy([{ orderBy: 'ItemModified', ascending: false }])
      .expand('Status')
      .get();

    return buildGlobalSearchHeaderSections(Array.from(items as Iterable<any>));
  } catch (error) {
    console.error('Error fetching paged inquiries:', error);
    throw error;
  }
};

export const fetchTopHundred = async (query='', me: any, userRoles: any) => {
  try {
    const list = await anewRListsHttp().getList(listName);
     const items = await list
      .query()
      .orderBy([{ orderBy: 'ItemModified', ascending: false }])
      .top(100)
      .filter(buildGlobalSearchRoleFilter(query, me, userRoles))
      .expand('Status')
      .get();

    return Array.from(items as Iterable<any>);
  } catch (error) {
    console.error('Error fetching paged inquiries:', error);
    throw error;
  }
};
export const deleteItem = async (eKey: string, eTag: string): Promise<boolean> => {
  const item={
    eKey: eKey,
    eTag: eTag,
    IsDeleted: true,
    
  }
  await updateItemToInquiryList(item,eKey,eTag)
  return true;
};
export const getItemById = async (id: string)=> {
    const list =await anewRViewsHttp().getview(viewName);
   const filter = `InquiryGUID eq '${safeFilterValue(id)}'`
    const items = await list
        .query()
        .filter(filter)
        .get();

    const itemsArray = Array.from(items as Iterable<any>);
    return itemsArray[0]  as any;
};
export const getInquiryItemById = async (id: string)=> {
    const list = await anewRListsHttp().getList(ListNames.InquiryList);
   const filter = `InquiryGUID eq '${safeFilterValue(id)}'`
    const items = await list
        .query()
        .filter(filter)
        .get();

    const itemsArray = Array.from(items as Iterable<any>);
    return itemsArray[0]  as any;
};

export const getItemByFilter= async (selectColumns: string[], filter: string) => {
    const list =await anewRViewsHttp().getview(viewName);
    const items = await list
        .query()
        .filter(filter)
        .select(...selectColumns)
        .get();
    const itemsArray = Array.from(items as Iterable<any>);
    return itemsArray  as any[];
}

export const getItemByFilterFromList = async ( filter: string, listName:string)=> {
    const list =await anewRListsHttp().getList(listName);
    const items = await list
        .query()
        .filter(filter)
        .get();
    const itemsArray = Array.from(items as Iterable<any>);
    return itemsArray as any;
};
export const postBlobInInquiryList = async(blobArray:File[],ekey:string,autherName:string)=>{
  await listAttachments(listName,ekey,blobArray,true,AnewTRMFolderPath,autherName)
}
export const postAutoFillBlobInInquiryList = async(blobArray:File[],ekey:string,autherName:string)=>{
  await listAttachments(listName,ekey,blobArray,true,AnewTRMFolderPath,autherName,true)
}
export const postTRMBulkTemplateList = async(blobArray:File[],ekey:string,autherName:string)=>{
    await listAttachments(bulkTemplateListName,ekey,blobArray,true,TRMTemplateFolderPath,autherName)
}


export const getBlobInInquiryList = async (ekey: string,isForm?:boolean): Promise<File[]> => {
  const filecontentArr: File[] = [];
  const listData = await anewRListsHttp().getList(AnewTRMFolderPath);
  const listBlobs: any = await listData.blobs().list(ekey);
  let files = listBlobs || [];
  
  if (isForm) {
    files = files.filter((file:{metadata?:Map<string,any>}) => file?.metadata?.get?.("isform"));
  }
  const list = await anewRListsHttp().getList(listName);

  // Download all attachment contents concurrently; results keep the listing order and a
  // missing/failed blob is skipped without affecting the others.
  const results = await Promise.all(files.map(async (blobInfo: any) => {
    try{
    const blobContent = await list
      .blobs()
      .getContent(ekey, blobInfo?.fileName, AnewTRMFolderPath);
    const file = new File(
      [blobContent],
      blobInfo.fileName,
      { type: blobInfo.metadata?.get("type")}
    );

    (file as any).isUploded = true;
    (file as any).createdOn = blobInfo?.createdOn ;
    (file as any).uplodedData = {itemKey: ekey, blobName: blobInfo?.metadata?.get("name"), createdBy: blobInfo?.metadata?.get("createdby"),createdByID: blobInfo?.createdBy,createDate:blobInfo?.metadata?.get('createdDate'), folderName: AnewTRMFolderPath, etag: blobInfo?.eTag, autofill: blobInfo?.metadata?.get('autofill')}

    return file;
    } catch (error) {
      console.error(`Failed to fetch attachment content for "${blobInfo?.fileName}":`, error)
      return null;
    }
  }));
  for (const file of results) {
    if (file) {
      filecontentArr.push(file);
    }
  }
  return filecontentArr;
};


export const getBlobInfoOnly = async (ekey: string, isForm?: boolean) => {
  const listData = await anewRListsHttp().getList(AnewTRMFolderPath);
  const listBlobs: any = await listData.blobs().list(ekey);
   let files = listBlobs || [];
    if (isForm) {
    files = files.filter((file: any) => file.metadata?.isform);
  }

  return files.map((file: any) => ({
    fileName: file.fileName,
    type: file.metadata?.type,
    createdOn: file.createdOn,
    metadata: {
      name: file.metadata?.name,
      createdBy: file.metadata?.get?.("createdby"),
      createdByID: file.createdBy,
      createdDate: file.metadata?.get?.("createdDate")
    },
    eTag: file?.eTag,
    itemKey: ekey,
    folderName: AnewTRMFolderPath
  }));
};





export const DeleteBlobInInquiryList = async (itemKey: string, blobName: string, folderName: string, etag: string)=> {
      const list = await anewRListsHttp().getList(ListNames.InquiryList);
       await list.blobs().delete(itemKey, blobName, folderName, etag)
}

const parseBlobMetadataValue = (metadata: any, key: string) => {
  if (!metadata) return undefined;
  if (typeof metadata.get === "function") {
    return metadata.get(key);
  }
  return metadata?.[key];
};

const mapMetadataListBlobInfo = (files: any[], itemKey: string, defaultFolderName: string) => {
  return (files || []).map((file: any) => ({
    fileName: file?.fileName,
    type: parseBlobMetadataValue(file?.metadata, "type"),
    createdOn: file?.createdOn,
    expiryDate: parseBlobMetadataValue(file?.metadata, "expiryDate"),
    state: parseBlobMetadataValue(file?.metadata, "state"),
    metadata: {
      name: parseBlobMetadataValue(file?.metadata, "name"),
      createdBy: parseBlobMetadataValue(file?.metadata, "createdby"),
      createdByID: file?.createdBy,
      createdDate: parseBlobMetadataValue(file?.metadata, "createdDate")
    },
    eTag: file?.eTag,
    itemKey,
    folderName: file?.folderName || defaultFolderName
  }));
};

// Shared by the account and sub-client document uploads, which differ only in the target list.
const postBlobsInMetadataList = async (metadataListName: string, blobArray: File[], ekey: string, authorName: string, expiryDate?: string, state?: string) => {
  const list = await anewRListsHttp().getList(metadataListName);
  const blobFolder = `/${metadataListName}`;
  await Promise.all(blobArray.map(async (file) => {
    const metadataEntries = [
      { Key: 'name', Value: file.name },
      { Key: 'size', Value: String(file.size) },
      { Key: 'type', Value: String(file.type) },
      { Key: 'createdby', Value: authorName },
      { Key: 'createdDate', Value: new Date().toISOString() }
    ];

    if (expiryDate?.trim()) {
      metadataEntries.push({ Key: 'expiryDate', Value: expiryDate.trim() });
    }

    if (state?.trim()) {
      metadataEntries.push({ Key: 'state', Value: state.trim() });
    }

    const metadata = JSON.stringify(metadataEntries);
    const formData = new FormData();
    formData.append('listName', metadataListName);
    formData.append('itemKey', ekey);
    formData.append('metadata', metadata);
    formData.append('blobName', file.name);
    formData.append('etag', '');
    formData.append('blobFolder', blobFolder);
    formData.append('file', file);
    try {
      await list.blobs().addOrUpdateByFormData(formData);
    } catch (error: any) {
      if (error?.message?.includes('ConcurrencyError') || error?.message?.includes('Failed to fetch')) {
        const newFileName = file.name.replace(/\.[^.]+$/, `_${Date.now()}.$&`);
        formData.set('blobName', newFileName);
        await list.blobs().addOrUpdateByFormData(formData);
      } else {
        throw error;
      }
    }
  }));
};

export const postBlobInAccountMetadataList = async (blobArray: File[], ekey: string, authorName: string, expiryDate?: string, state?: string) =>
  postBlobsInMetadataList(ListNames.TRMAccountSettingMetadataList, blobArray, ekey, authorName, expiryDate, state);

export const getBlobAccountMetadataList = async (ekey: string) => {
  const list = await anewRListsHttp().getList(ListNames.TRMAccountSettingMetadataList);
  const listBlobs: any = await list.blobs().list(ekey);
  return mapMetadataListBlobInfo(listBlobs || [], ekey, `/${ListNames.TRMAccountSettingMetadataList}`);
};

export const deleteBlobInAccountMetadataList = async (itemKey: string, blobName: string, folderName: string, etag: string) => {
  const list = await anewRListsHttp().getList(ListNames.TRMAccountSettingMetadataList);
  await list.blobs().delete(itemKey, blobName, folderName, etag);
};

export const postBlobInSubClientMetadataList = async (blobArray: File[], ekey: string, authorName: string, expiryDate?: string, state?: string) =>
  postBlobsInMetadataList(ListNames.TRMSubClientSettingMetadataList, blobArray, ekey, authorName, expiryDate, state);

export const getBlobSubClientMetadataList = async (ekey: string) => {
  const list = await anewRListsHttp().getList(ListNames.TRMSubClientSettingMetadataList);
  const listBlobs: any = await list.blobs().list(ekey);
  return mapMetadataListBlobInfo(listBlobs || [], ekey, `/${ListNames.TRMSubClientSettingMetadataList}`);
};

export const deleteBlobInSubClientMetadataList = async (itemKey: string, blobName: string, folderName: string, etag: string) => {
  const list = await anewRListsHttp().getList(ListNames.TRMSubClientSettingMetadataList);
  await list.blobs().delete(itemKey, blobName, folderName, etag);
};

export const fetchAllInquiries = async (
  filterQuery: string = "",
  selectColumns:string[],
  isCurrent: () => boolean = () => true,
  // Called with each batch as it arrives, so a later batch failing no longer discards the
  // ones already fetched: a sync too large to finish in one run still makes progress, and the
  // next run resumes from the stored watermark. NOTE: when this is supplied the batches are
  // not also accumulated, so the returned array is empty — consume the data here, not from
  // the return value.
  onBatch?: (items: any[]) => Promise<void>
): Promise<{ items: any[]; complete: boolean }> => {
  let allItems: any[] = [];
  let complete = false;
  try {

const viewsData = await anewRViewsHttp().getview(viewName);

    let query = viewsData.query();
    if (filterQuery) {
      query = query.filter(`${filterQuery}`);
    }

    const countResult = [...(await viewsData.query().filter(filterQuery).select(InquiryViewColumns.InquiryGUID).count(InquiryViewColumns.InquiryGUID).distinct(true).get())][0] as {InquiryGUID_count:number};
    const totalCount = countResult?.InquiryGUID_count || 0;
    if (totalCount > 0) {
      let batchIndex = 0;
      const pageSize = 5000;
      let fetchedCount = 0;
      while (fetchedCount < totalCount) {
        // Stop issuing further batches once a newer sync for this store has started elsewhere
        // (e.g. the user navigated away) — the in-flight request can't be cancelled, but this
        // request will be its last.
        if (!isCurrent()) return { items: allItems, complete: false };
        const items = [...(await query
          .select(...selectColumns)
          // Ascending on ItemModifiedOn — the same column getLatestModifiedDate reads the sync
          // watermark from. Ordering by anything else (or descending) would leave a partially
          // written store claiming a watermark newer than the rows it actually holds, and the
          // next sync would skip everything in between.
          .orderBy([
            { orderBy: InquiryViewColumns.ModifiedOn, ascending: true },
            { orderBy: InquiryViewColumns.InquiryGUID, ascending: true },
          ])
          .top(pageSize)
          .skip(batchIndex * pageSize)
          .distinct(true)
          .get())];
        if (items.length === 0) break;
        if (onBatch) {
          await onBatch(items);
        } else {
          // Only accumulate when nobody is consuming batches as they arrive; holding every
          // row as well as writing it doubles peak memory on a large first sync.
          allItems = [...allItems, ...items];
        }
        fetchedCount += items.length;
        batchIndex++;
      }
    }
    complete = true;
  } catch (error) {
    console.error("Error fetching inquiries:", error);
  }
  return { items: allItems, complete };
};

export const fetchPagedInquiriesList = async (
  filterQuery: string = "",
  pageNumber: number,
  sortOrder?: { field: string; ascending: boolean },
) => {
      
  try {
    
    const viewsData = await anewRListsHttp().getList(listName)
    let query = viewsData.query();
    if (filterQuery !== "") {
      query = query.filter(filterQuery);
    }

          const items = await query
            .orderBy([sortOrder ? { orderBy: sortOrder.field, ascending: sortOrder.ascending } : { orderBy: "ItemModified", ascending: false }])
            .expand('Status')
            .get();

    return [...items];
  } catch (error) {
    console.error("Error fetching paged inquiries:", error);
    return [];
  }
  
};
// const getDuplicateKeys = (items: any[], keyPath: string = 'eKey') => {
//   const counts: Record<string, number> = {};
//   const duplicateIDs: Record<string, any[]> = {};
//   const index: Record<string, any> = {};

//   items.forEach((item,i) => {
//     const key = item[keyPath];
//     counts[key] = (counts[key] || 0) + 1;
//       duplicateIDs[key] = duplicateIDs[key] || [];
//       duplicateIDs[key].push(item.ID); // Assuming 'ID' is the unique identifier for the item
//       index[key] = index[key] || [];
//       index[key].push(i); // Storing the index of the item in the original array
//   });

//   return Object.entries(counts)
//     .filter(([_, count]) => count > 1)
//     .map(([key, count]) => ({ key, count, duplicateIDs: duplicateIDs[key], index: index[key] }));
// };
export const fetchPagedInquiries = async (
  filterQuery: string = "",
  pageNumber: number,
  sortOrder?: { field: string; ascending: boolean },
) => {
  const firstBatch = 100;
  const nextBatch = 20;

  const batchSize = pageNumber === 0 ? firstBatch : nextBatch;

  const skip =
    pageNumber === 0
      ? 0
      : firstBatch + (pageNumber - 1) * nextBatch;
      
  try {
    const selectColumns = [
      InquiryViewColumns.InquiryeKey,
      InquiryViewColumns.InquiryGUID,
      InquiryViewColumns.StatusTitle,
      InquiryViewColumns.VINNumber,
      InquiryViewColumns.ProcessType,
      InquiryViewColumns.StatusCode,
      InquiryViewColumns.State,
      InquiryViewColumns.County,
      InquiryViewColumns.AccName,
      InquiryViewColumns.ID,
      InquiryViewColumns.ItemModified,
      InquiryViewColumns.AnewAccountOwner,
      InquiryViewColumns.ItemCreated,
      InquiryViewColumns.Year,
      InquiryViewColumns.Make,
      InquiryViewColumns.Model,
      InquiryViewColumns.Trim,
      InquiryViewColumns.VehicleType, 
      InquiryViewColumns.Color,
      InquiryViewColumns.OwnershipType,
      InquiryViewColumns.GrossVehicleWeight,
      InquiryViewColumns.Odometer,
      InquiryViewColumns.PlateType,
      InquiryViewColumns.VehicleUnitNumber,
      InquiryViewColumns.LicensePlateNumber,
      InquiryViewColumns.RegExpirationDate,
      InquiryViewColumns.IsDeleted,
      InquiryViewColumns.IsWorkOrder,
      InquiryViewColumns.InquiryeTag,
      InquiryViewColumns.CanceledDate,
      InquiryViewColumns.SubmittedDate,
      InquiryViewColumns.WorkOrderCreated,
      InquiryViewColumns.SubClientName,
      InquiryViewColumns.AssignedProcessor,
      InquiryViewColumns.Territory,
      InquiryViewColumns.IsInboundActionRequired,
      InquiryViewColumns.IsPendingProblem,
      InquiryViewColumns.IsRequestForCancelation,
      InquiryViewColumns.IsSalesRequired,
      InquiryViewColumns.ItemCreatedBy,
      InquiryViewColumns.ETCDate,
      InquiryViewColumns.TMSID,
      InquiryViewColumns.PreviousStatusCode,
      InquiryViewColumns.ArchivedDate,
      InquiryViewColumns.CompletedDate,
      InquiryViewColumns.TeamMembers,
      InquiryViewColumns.PhoneName,
      InquiryViewColumns.Lien,
      InquiryViewColumns.AdditionalInformation,
      InquiryViewColumns.FEINNumber,
      InquiryViewColumns.PointOfContact,
      InquiryViewColumns.Email,
      InquiryViewColumns.TaxExempt,
      InquiryViewColumns.ModifiedOn,
]
    const viewsData = await anewRViewsHttp().getview(viewName);
    let query = viewsData.query();
    if (filterQuery !== "") {
      query = query.filter(filterQuery);
    }

          const items = await query
            .select(...selectColumns)
            .orderBy([sortOrder ? { orderBy: sortOrder.field, ascending: sortOrder.ascending } : { orderBy: "ItemModified", ascending: false }])
            .top(batchSize)
            .skip(skip)
            .get();

    return [...items];
  } catch (error) {
    console.error("Error fetching paged inquiries:", error);
    return [];
  }

};

// Only the GUID and the dates Age is derived from, so Age can be sorted without loading full rows
export const fetchAgeSortKeys = async (filterQuery: string = "") => {
  try {
    const selectColumns = [
      InquiryViewColumns.InquiryGUID,
      InquiryViewColumns.IsWorkOrder,
      InquiryViewColumns.SubmittedDate,
      InquiryViewColumns.ItemCreated,
      InquiryViewColumns.ItemModified,
      InquiryViewColumns.ModifiedOn,
      InquiryViewColumns.WorkOrderCreated,
      InquiryViewColumns.CompletedDate,
      InquiryViewColumns.CanceledDate,
    ]
    const viewsData = await anewRViewsHttp().getview(viewName);
    let query = viewsData.query();
    if (filterQuery !== "") {
      query = query.filter(filterQuery);
    }
    const pageSize = 5000;
    let allItems: any[] = [];
    for (let batchIndex = 0; ; batchIndex++) {
      const items = [...(await query
        .select(...selectColumns)
        .orderBy([{ orderBy: "ItemModified", ascending: false }])
        .top(pageSize)
        .skip(batchIndex * pageSize)
        .get())];
      allItems = [...allItems, ...items];
      if (items.length < pageSize) break;
    }
    return allItems;
  } catch (error) {
    console.error("Error fetching age sort keys:", error);
    return [];
  }
};



export const getTabAndStatusCount = async (filterQuery: string = "",) =>{
const viewsData = await anewRViewsHttp().getview(viewName);
const countResult = [...(await viewsData.query().filter(`${filterQuery}`).select(InquiryViewColumns.InquiryGUID).count(InquiryViewColumns.InquiryGUID).get())][0] as {InquiryGUID_count:number};
return countResult?.InquiryGUID_count || 0;
}

export const fetchArchivedInquiries = async (
  filterQuery: string = "",
) => {
  try {
    let allItems: any[] = [];
    const selectColumns = [
      InquiryViewColumns.InquiryeKey,
]
const viewsData = await anewRViewsHttp().getview(viewName);
    let query = viewsData.query();
    if (filterQuery) {
      query = query.filter(`${filterQuery}`);
    }
    const countResult = [...(await viewsData.query().filter(`${filterQuery}`).select(InquiryViewColumns.InquiryGUID).count(InquiryViewColumns.InquiryGUID).get())][0] as {InquiryGUID_count:number};
    if(countResult?.InquiryGUID_count && countResult.InquiryGUID_count>0){
      if(countResult.InquiryGUID_count>5000){
        let batchIndex=0;
        const pageSize=5000;
        let fetchedCount=0;
        while(fetchedCount < countResult.InquiryGUID_count){
          const items = await query
            .select(...selectColumns)
            .top(pageSize)
            .skip(batchIndex*pageSize)
            .get();
          allItems = [...allItems, ...items];
          fetchedCount += [...items].length;
          batchIndex++;
        }
      }
      else{
        allItems = [...(await query.select(...selectColumns).get())];
      }
    }

    return allItems;
  } catch (error) {
    console.error("Error fetching inquiries:", error);
    throw error;
  }
  
};


export const indexDB = async () => {
  return dbStore(IDB_INQUIRY_LIST_STORE, IDB_INQUIRY_LIST_KEYPATH);
};


const toODataDate = (timestamp: number | string | Date) => new Date(timestamp).toISOString();

// Columns cached in IndexedDB for the inquiry/work-order list views (active and archived stores).
const SYNCED_INQUIRY_COLUMNS = [
  InquiryViewColumns.InquiryeKey,
  InquiryViewColumns.InquiryGUID,
  InquiryViewColumns.StatusTitle,
  InquiryViewColumns.VINNumber,
  InquiryViewColumns.ProcessType,
  InquiryViewColumns.StatusCode,
  InquiryViewColumns.State,
  InquiryViewColumns.County,
  InquiryViewColumns.AccName,
  InquiryViewColumns.ID,
  InquiryViewColumns.ItemModified,
  InquiryViewColumns.AnewAccountOwner,
  InquiryViewColumns.ItemCreated,
  InquiryViewColumns.Year,
  InquiryViewColumns.Make,
  InquiryViewColumns.Model,
  InquiryViewColumns.Trim,
  InquiryViewColumns.VehicleType,
  InquiryViewColumns.Color,
  InquiryViewColumns.OwnershipType,
  InquiryViewColumns.GrossVehicleWeight,
  InquiryViewColumns.Odometer,
  InquiryViewColumns.PlateType,
  InquiryViewColumns.VehicleUnitNumber,
  InquiryViewColumns.LicensePlateNumber,
  InquiryViewColumns.RegExpirationDate,
  InquiryViewColumns.TitleNumber,
  InquiryViewColumns.IsDeleted,
  InquiryViewColumns.IsWorkOrder,
  InquiryViewColumns.InquiryeTag,
  InquiryViewColumns.CanceledDate,
  InquiryViewColumns.SubmittedDate,
  InquiryViewColumns.WorkOrderCreated,
  InquiryViewColumns.SubClientName,
  InquiryViewColumns.AssignedProcessor,
  InquiryViewColumns.Territory,
  InquiryViewColumns.IsInboundActionRequired,
  InquiryViewColumns.IsPendingProblem,
  InquiryViewColumns.IsRequestForCancelation,
  InquiryViewColumns.IsSalesRequired,
  InquiryViewColumns.ItemCreatedBy,
  InquiryViewColumns.ETCDate,
  InquiryViewColumns.TMSID,
  InquiryViewColumns.PreviousStatusCode,
  InquiryViewColumns.CompletedDate,
  InquiryViewColumns.ModifiedOn,
  InquiryViewColumns.IsArchived,
  InquiryViewColumns.ArchivedDate,
]

// Applies an incremental sync batch to a store: soft-deleted rows are evicted, everything else is upserted.
const applySyncedItemsToStore = async (storeName: string, syncedItems: any[]) => {
  const deletedItems = syncedItems.filter((item) => item.IsDeleted)
  const updatedItems = syncedItems.filter((item) => !item.IsDeleted)
  await deleteItemsInStore(storeName, deletedItems, IDB_INQUIRY_LIST_KEYPATH)
  await saveItems(storeName, updatedItems, IDB_INQUIRY_LIST_KEYPATH);
}

export const fetchAndSyncArchivedInquiries = async (
  me: any,
  userRoles: any,
  extraFilter: string = ""
) => {
  const selectColumns = SYNCED_INQUIRY_COLUMNS
  try {
    const LastModified = await getLatestModifiedDate(IDB_ARCHIVED_INQUIRY_LIST_STORE,InquiryViewColumns.ModifiedOn,IDB_INQUIRY_LIST_KEYPATH)
    const localLastModified = LastModified ? new Date(LastModified).getTime() : new Date(0).getTime();
    const roleFilter = buildRoleFilter(me, userRoles)
    const filterQuery = extraFilter ? `${roleFilter} and ${extraFilter}`.trim() : roleFilter.trim()
    // "ge", not "gt": rows sharing the newest stored timestamp would otherwise be skipped
    // forever. Re-reading that boundary costs one timestamp's worth of rows and the store
    // upserts by key, so the overlap is harmless.
    await fetchAllInquiries(
      `${filterQuery} and ${InquiryViewColumns.ModifiedOn} ge ${toODataDate(localLastModified)} and IsArchived eq true`,
      selectColumns,
      () => true,
      (batch) => applySyncedItemsToStore(IDB_ARCHIVED_INQUIRY_LIST_STORE, batch)
    )

    return await getAllItemsInStore(IDB_ARCHIVED_INQUIRY_LIST_STORE,IDB_INQUIRY_LIST_KEYPATH) as any[];
  } catch (error) {
    console.error("Error in fetchAndSyncArchivedInquiries", error)
    // Batches already written survive; hand back what the store holds so the page renders
    // partial data instead of nothing, and let the next run resume from the watermark.
    return await getAllItemsInStore(IDB_ARCHIVED_INQUIRY_LIST_STORE,IDB_INQUIRY_LIST_KEYPATH) as any[];
  }
}


export const fetchAndSyncInquiries = async (
  me: any,
  userRoles: any,
  extraFilter: string = "",
  forceRefresh: boolean = false
) => {
  const selectColumns = [...SYNCED_INQUIRY_COLUMNS, InquiryViewColumns.Lien]
  // Claim this store for this call. Inquiries, Work Orders, and the Dashboard widgets can each
  // start a sync independently (e.g. one page's sync is still in flight when the user navigates
  // to another), and without this, an abandoned sync's batch fetch keeps issuing requests and its
  // writes contend for the same IndexedDB readwrite transaction as the page the user is actually on.
  const syncSession = beginSyncSession(IDB_INQUIRY_LIST_STORE)
  const isSyncCurrent = () => isSyncSessionCurrent(IDB_INQUIRY_LIST_STORE, syncSession)

  try {
    const LastModified = forceRefresh ? null : await getLatestModifiedDate(IDB_INQUIRY_LIST_STORE,InquiryViewColumns.ModifiedOn,IDB_INQUIRY_LIST_KEYPATH)
    const localLastModified = LastModified ? new Date(LastModified).getTime() : new Date(0).getTime();
    const roleFilter = buildRoleFilter(me, userRoles)
    const filterQuery = extraFilter ? `${roleFilter} and ${extraFilter}`.trim() : roleFilter.trim()
    if (forceRefresh && isSyncCurrent()) {
      await clearStore(IDB_INQUIRY_LIST_STORE, IDB_INQUIRY_LIST_KEYPATH)
    }
    // See fetchAndSyncArchivedInquiries: "ge" so rows sharing the watermark aren't lost.
    const modifiedFilter = forceRefresh ? "" : ` and ${InquiryViewColumns.ModifiedOn} ge ${toODataDate(localLastModified)}`
    const persistBatch = async (batch: any[]) => {
      if (isSyncCurrent()) await applySyncedItemsToStore(IDB_INQUIRY_LIST_STORE, batch)
    }

    let passFilter = `${filterQuery}${modifiedFilter} and IsArchived eq false`
    let continuations = 0
    while (true) {
      const { complete } = await fetchAllInquiries(passFilter, selectColumns, isSyncCurrent, persistBatch)
      if (complete || !isSyncCurrent() || continuations >= MAX_SYNC_CONTINUATIONS) break
      continuations++
      const resumeFrom = await getLatestModifiedDate(IDB_INQUIRY_LIST_STORE, InquiryViewColumns.ModifiedOn, IDB_INQUIRY_LIST_KEYPATH)
      const resumeAt = resumeFrom ? new Date(resumeFrom).getTime() : new Date(0).getTime()
      passFilter = `${filterQuery} and ${InquiryViewColumns.ModifiedOn} ge ${toODataDate(resumeAt)} and IsArchived eq false`
    }

    if (!isSyncCurrent()) {
      // A newer sync for this store has started elsewhere (e.g. the user navigated away).
      // Skip writing this now-stale batch and hand back whatever the current sync has already
      // written, rather than holding up its IndexedDB transaction with abandoned work.
      return await getAllItemsInStore(IDB_INQUIRY_LIST_STORE,IDB_INQUIRY_LIST_KEYPATH) as any[];
    }

    // Rows archived since the last sync no longer match "IsArchived eq false", so the delta query
    // above won't return them; fetch their keys separately and evict them from the active store.
    if (LastModified) {
      const archivedItems: any = await fetchArchivedInquiries(`${filterQuery} and ${InquiryViewColumns.ModifiedOn} ge ${toODataDate(localLastModified)} and IsArchived eq true`)
      if (archivedItems && archivedItems.length > 0 && isSyncCurrent()) {
        await deleteItemsInStore(IDB_INQUIRY_LIST_STORE, archivedItems, IDB_INQUIRY_LIST_KEYPATH)
      }
    }
    // No flush needed here: onBatch wrote each batch as it arrived.
    return await getAllItemsInStore(IDB_INQUIRY_LIST_STORE,IDB_INQUIRY_LIST_KEYPATH) as any[];
  } catch (error) {
    console.error("Error in fetchAndSyncInquiries", error)
    // Whatever batches completed are already in the store. Returning them keeps the page
    // usable on a partial sync and lets the next run continue from the watermark, instead of
    // throwing and leaving the UI empty with nothing persisted.
    return await getAllItemsInStore(IDB_INQUIRY_LIST_STORE,IDB_INQUIRY_LIST_KEYPATH) as any[];
  }
}
export const getAccountInformationData = async () => {
  const list = await anewRListsHttp().getList(ListNames.TRMAccountSettingMetadataList);

  const items = await list
    .query()
    .select(...Object.values(TRMAccountMetadataListSelectColumns))
    .expand('ItemCreatedBy', 'ItemModifiedBy','AccOwnerID')
    .orderBy([{ orderBy: 'ItemCreated', ascending: false }])
    .get();

  return items;
};
export const getSubClinetMetadataList = async () => {
  const list = await anewRListsHttp().getList(ListNames.TRMSubClientSettingMetadataList);

  const items = await list
    .query()
    .select(...Object.values(TRMSubClientSettingMetadataListColumns))
    .expand('ItemCreatedBy', 'ItemModifiedBy','subOwnerID')
    .orderBy([{ orderBy: 'ItemCreated', ascending: false }])
    .get();

  return items;
};
export const getAccTaxExemptMetadataList = async () => {
  const list = await anewRListsHttp().getList(ListNames.TRMAccTaxExemptionList);
    const items = await list
    .query()
    .select(...Object.values(TRMAccTaxExemptionListColumns))
    .expand('ItemCreatedBy', 'ItemModifiedBy')
    .orderBy([{ orderBy: 'ItemCreated', ascending: false }])
    .get();
  return items;
 
}; 
export const getsubClientTaxExemptMetadataList = async () => {
  const list = await anewRListsHttp().getList(ListNames.TRMSubClientTaxExemptionList);
    const items = await list
    .query()
    .select(...Object.values(TRMSubClientTaxExemptionListColumns))
    .expand('ItemCreatedBy', 'ItemModifiedBy')
    .orderBy([{ orderBy: 'ItemCreated', ascending: false }])
    .get();

  return items;
}; 




export const deleteAccountItemAPI = async (eKey: string, eTag: string) => {
  const list = await anewRListsHttp().getList(ListNames.TRMAccountSettingMetadataList);
  const item = await list.deleteItem(eKey,eTag);
  return item;
};
export const fetchFeeCalculationExportData = async (filterQuery: string = '') => {
  try {
    const viewsData = await anewRViewsHttp().getview(ListNames.V_FeeCalculationList);
    let allItems: any[] = [];

    const countQuery = viewsData.query();
    if (filterQuery) countQuery.filter(filterQuery);

    const countResult = [
      ...(await countQuery.select('ID').count('ID').get())
    ][0] as { ID_count: number };

    const totalCount = countResult?.ID_count ?? 0;
    if (totalCount > 0) {
      const pageSize = 5000;
      if (totalCount > pageSize) {
        let batchIndex = 0;
        let fetchedCount = 0;
        while (fetchedCount < totalCount) {
          const dataQuery = viewsData.query();
          if (filterQuery) dataQuery.filter(filterQuery);
          const items = await dataQuery
            .top(pageSize)
            .skip(batchIndex * pageSize)
            .get();
          const batchItems = [...items];
          allItems = [...allItems, ...batchItems];
          fetchedCount += batchItems.length;
          batchIndex++;
          if (batchItems.length === 0) break;
        }
      } else {
        const dataQuery = viewsData.query();
        if (filterQuery) dataQuery.filter(filterQuery);
        allItems = [...(await dataQuery.get())];
      }
    }

    return allItems;
  } catch (error) {
    console.error('Error fetching fee calculation export data:', error);
    throw error;
  }
};

export const fetchedRefinedExportdata = async (me: any,userRoles: any,extraFilter: string = "",defaultSelectedColumns:any[]) => {
  try {
   const roleFilter = buildRoleFilter(me, userRoles, 'Export')
    const filterQuery = extraFilter ? `${roleFilter} and ${extraFilter}`.trim() : roleFilter.trim()
    const updatedItems: any = await fetchExportViewData(`${filterQuery}`, defaultSelectedColumns)
    return updatedItems;
  } catch (error) {
    console.error("Error in fetchedRefinedExportdata", error)
    throw error
}}
export const fetchExportViewData = async (rolefilter: string = "", selectedColumns:any[],sortOrder?: { field: string; ascending: boolean }) => {
  try {
    const viewsData = await anewRViewsHttp().getview(viewNameForExport);
    let allItems: any[] = [];
    //  COUNT QUERY (Separate query instance)
    const countQuery = viewsData.query();
    if (rolefilter) {
      countQuery.filter(rolefilter);
    }

    const countResult = [
      ...(await countQuery
        .select(TRMExportInquiryColumns.InquiryGUID)
        .count(TRMExportInquiryColumns.InquiryGUID)
        .get())
    ][0] as { InquiryGUID_count: number };

    if (countResult?.InquiryGUID_count && countResult.InquiryGUID_count > 0) {

      const totalCount = countResult.InquiryGUID_count;

      // DATA QUERY (Separate query instance)
      const dataQuery = viewsData.query();
      if (rolefilter) {
        dataQuery.filter(rolefilter);
      }

      if (totalCount > 5000) {
        let batchIndex = 0;
        const pageSize = 5000;
        let fetchedCount = 0;

       while (fetchedCount < totalCount) {
       const normalize = (val: string) => val === 'Status/StatusTitle' || val === 'Status' ? 'StatusTitle' : val==='IsSalesRequired' || val === 'IsInboundActionRequired' ||  val === 'IsRequestForCancelation' ? 'ActionRequiredStatus' : val==='WorkOrderAge' ? 'WorkOrderCreated' : val === 'InquiryAge' ? 'SubmittedDate' : val;
       const selectedFieldNames = selectedColumns.filter((col: any) => col.IsSelected && Object.values(TRMExportInquiryColumns).includes(normalize(col.fieldName))).map((col: any) => normalize(col.fieldName));
       const actionReqiuredSelected = selectedColumns.find((col: any) => col.fieldName === 'ActionRequiredStatus' && col.IsSelected);
       let finalColumns = selectedFieldNames.length > 0 ? selectedFieldNames : Object.values(TRMExportInquiryColumns);
          finalColumns.push(TRMExportInquiryColumns.InquiryGUID, TRMExportInquiryColumns.ItemModified,TRMExportInquiryColumns.IsWorkOrder)
           if (actionReqiuredSelected) {
        finalColumns.push('IsInboundActionRequired', 'IsRequestForCancelation', 'IsSalesRequired')
       }
          finalColumns = [...new Set(finalColumns)];
          const items = await dataQuery
            .select(...finalColumns)
            .orderBy([sortOrder ? { orderBy: sortOrder.field, ascending: sortOrder.ascending } : { orderBy: "ItemModified", ascending: false }])
            .top(pageSize)
            .skip(batchIndex * pageSize)
            .get();

          const batchItems = [...items];
          allItems = [...allItems, ...batchItems];

          fetchedCount += batchItems.length;
          batchIndex++;
        }

      } else {
       const normalize = (val: string) => val === 'Status/StatusTitle' || val === 'Status' ? 'StatusTitle' : val==='IsSalesRequired' || val === 'IsInboundActionRequired' ||  val === 'IsRequestForCancelation' ? 'ActionRequiredStatus' : val==='WorkOrderAge' ? 'WorkOrderCreated' : val === 'InquiryAge' ? 'SubmittedDate' : val;
         const actionReqiuredSelected = selectedColumns.find((col: any) => col.fieldName === "ActionRequiredStatus" && col.IsSelected);
         const selectedFieldNames = selectedColumns.filter((col: any) => col.IsSelected && Object.values(TRMExportInquiryColumns).includes(normalize(col.fieldName))).map((col: any) => normalize(col.fieldName));
      
       
        let finalColumns = selectedFieldNames.length > 0 ? selectedFieldNames : Object.values(TRMExportInquiryColumns);
        finalColumns.push(TRMExportInquiryColumns.InquiryGUID, TRMExportInquiryColumns.ItemModified,TRMExportInquiryColumns.IsWorkOrder)
        if (actionReqiuredSelected) {
        finalColumns.push('IsInboundActionRequired','IsRequestForCancelation', 'IsSalesRequired')
       }
       finalColumns = [...new Set(finalColumns)];
        allItems = [
          ...(await dataQuery
            .select(...finalColumns)
            .orderBy([sortOrder ? { orderBy: sortOrder.field, ascending: sortOrder.ascending } : { orderBy: "ItemModified", ascending: false }])
            .get())
        ];
      }
    }

    return allItems;

  } catch (error) {
    console.error("Error fetching inquiries:", error);
    throw error;
  }
};

export const getAvailableColumnsByReference = async (source: string) => {
  try {
    const list = await anewRListsHttp().getList(exportColumnConfigurationListName)
    const items = await list
      .query()
      .filter(`Source eq '${safeFilterValue(source)}'`)
      .orderBy([{ orderBy: "ItemModified", ascending: false }])
      .top(1)
      .get()

    const result = [...(items as any[])]
    if (result.length > 0 && result[0]?.SourceColumns) {
      localStorage.setItem(getConfigurationStorageKey(source), result[0].SourceColumns)
    }
    return result
  } catch (error) {
    const stored = localStorage.getItem(getConfigurationStorageKey(source))
    if (!stored) return []
    return [{ Source: source, SourceColumns: stored }]
  }
}

export const getUserPreferences = async (userId: string, source: string = "Listview") => {
  try {
    const list = await anewRListsHttp().getList(userPreferenceListName)
    const items = await list
      .query()
      .filter(`UserId eq '${safeFilterValue(userId)}' and Source eq '${safeFilterValue(source)}'`)
      .orderBy([{ orderBy: "ItemModified", ascending: false }])
      .top(1)
      .get()

    const result = [...(items as any[])]
    if (result.length > 0) {
      localStorage.setItem(getPreferenceStorageKey(userId, source), JSON.stringify(result[0]))
    }
    return result
  } catch (error) {
    const stored = localStorage.getItem(getPreferenceStorageKey(userId, source))
    if (!stored) return []
    try {
      return [JSON.parse(stored)]
    } catch {
      return []
    }
  }
}

export const saveUserPreferences = async (
  userId: string,
  columns: ExportColumnConfig[],
  source: string = "Listview",
  uniqueIdentifier: string = "1",
  preferenceId?: string,
  isReset: boolean = false
) => {
  const payload: any = {
    UserId: userId,
    Source: source,
    UniqueIdentifier: uniqueIdentifier,
    SelectedColumns: JSON.stringify(columns),
    IsReset: isReset
  }

  try {
    const list = await anewRListsHttp().getList(userPreferenceListName)
    const existing = await list
      .query()
      .filter(`UserId eq '${safeFilterValue(userId)}' and Source eq '${safeFilterValue(source)}'`)
      .orderBy([{ orderBy: "ItemModified", ascending: false }])
      .top(1)
      .get()
    const existingItem = [...(existing as any[])][0]

    if (existingItem?.eKey && existingItem?.eTag) {
      payload.eKey = existingItem.eKey
      payload.eTag = existingItem.eTag
      payload.ID = existingItem.ID
    } else if (preferenceId) {
      payload.ID = preferenceId
    }

    const savedItem = await list.addOrUpdateItem(payload)
    localStorage.setItem(
      getPreferenceStorageKey(userId, source),
      JSON.stringify({
        ...payload,
        ...(savedItem || {})
      })
    )
    return savedItem
  } catch (error) {
    localStorage.setItem(
      getPreferenceStorageKey(userId, source),
      JSON.stringify({
        ...payload,
        ID: preferenceId || `${source}-${userId}`
      })
    )
    return { success: true, isLocal: true }
  } 
}
  
export const inquiryReportData= async (filterQuery?: string)=>{
  const inquiryFields = [
     TRMExportInquiryColumns.ID,
    TRMExportInquiryColumns.AccName,
    TRMExportInquiryColumns.SubClientName,
    TRMExportInquiryColumns.FEINNumber,
    TRMExportInquiryColumns.TaxExemptNo,
    TRMExportInquiryColumns.PointOfContact,
    TRMExportInquiryColumns.State,
    TRMExportInquiryColumns.Territory,
    TRMExportInquiryColumns.County,
    TRMExportInquiryColumns.AnewAccountOwner,
    TRMExportInquiryColumns.ProcessType,
    TRMExportInquiryColumns.VINNumber,
    TRMExportInquiryColumns.Lien,
    TRMExportInquiryColumns.StatusTitle,
    TRMExportInquiryColumns.SubmittedDate,
    TRMExportInquiryColumns.WorkOrderCreated,
    TRMExportInquiryColumns.CanceledDate,
    TRMExportInquiryColumns.ArchivedDate,
    TRMExportInquiryColumns.CompletedDate,
    TRMExportInquiryColumns.ETCDate,
    TRMExportInquiryColumns.IsPendingProblem,
    TRMExportInquiryColumns.IsRequestForCancelation,
    TRMExportInquiryColumns.IsInboundActionRequired,
    TRMExportInquiryColumns.IsSalesRequired,
    TRMExportInquiryColumns.IsWorkOrder,
    TRMExportInquiryColumns.IsArchived,
    TRMExportInquiryColumns.Year,
    TRMExportInquiryColumns.Make,
    TRMExportInquiryColumns.Model,
    TRMExportInquiryColumns.Trim,
    TRMExportInquiryColumns.FuelType,
    TRMExportInquiryColumns.OwnershipType,
    TRMExportInquiryColumns.VehicleType,
    TRMExportInquiryColumns.GrossVehicleWeight,
    TRMExportInquiryColumns.EmptyVehicleWeight,
    TRMExportInquiryColumns.PlateType,
    TRMExportInquiryColumns.LicensePlateNumber,
    TRMExportInquiryColumns.Odometer,
    TRMExportInquiryColumns.RegExpirationDate,
    TRMExportInquiryColumns.TitleNumber,
    TRMExportInquiryColumns.TitleState,
    TRMExportInquiryColumns.LienHolderName,
    TRMExportInquiryColumns.LienHolderNumber,
    TRMExportInquiryColumns.LienDate,
    TRMExportInquiryColumns.LienHolderStreetName,
    TRMExportInquiryColumns.PolicyNumber,
    TRMExportInquiryColumns.PolicyHolder,
    TRMExportInquiryColumns.ExpirationDate,
    TRMExportInquiryColumns.InsuranceCompanyName,
    TRMExportInquiryColumns.InsurancePhoneNumber,
    TRMExportInquiryColumns.InsuranceStreetName,
    TRMExportInquiryColumns.ShippingStreetName,
    TRMExportInquiryColumns.ItemModified,
    TRMExportInquiryColumns.ProblemTitle,
    TRMExportInquiryColumns.ActionComment,
    TRMExportInquiryColumns.Comment,
    TRMExportInquiryColumns.TrackingNumber,
    TRMExportInquiryColumns.Email,
    TRMExportInquiryColumns.PhoneName,
    TRMExportInquiryColumns.Color,
    TRMExportInquiryColumns.TeamMembers,
    TRMExportInquiryColumns.AdditionalInformation,
    TRMExportInquiryColumns.DriverName,
    TRMExportInquiryColumns.DriverEmail,
    TRMExportInquiryColumns.DriverPhone,
    TRMExportInquiryColumns.DriverStreetName,
    TRMExportInquiryColumns.TMSID,
    TRMExportInquiryColumns.VehicleUnitNumber,
];
  const inquiryData=await fetchAllExportViewInquiries(filterQuery,inquiryFields)
  const historyData = await fetchAllInquiriesHistoryView(filterQuery)
  return {inquiryData,historyData}

}

export const fetchAllInquiriesHistoryView = async (
  filterQuery: string = "",
) => {
  try {
    let allItems: any[] = [];
const viewsData = await anewRViewsHttp().getview(ListNames.V_TRMInquiryHistoryList);

    let query = viewsData.query();
    if (filterQuery) {
      query = query.filter(`${filterQuery}`);
    }
  const historyFields = [
    V_TRMInquiryHistoryListColoums.ID,
    V_TRMInquiryHistoryListColoums.VINNumber,
    V_TRMInquiryHistoryListColoums.AccName,
    V_TRMInquiryHistoryListColoums.StatusTitle,
    V_TRMInquiryHistoryListColoums.StatusCode,
    V_TRMInquiryHistoryListColoums.PreviousStatusCode,
    V_TRMInquiryHistoryListColoums.Action,
    V_TRMInquiryHistoryListColoums.CreatedOn,
    V_TRMInquiryHistoryListColoums.CreatedBy,
    V_TRMInquiryHistoryListColoums.Comment,
  ];
    const countResult = [...(await viewsData.query().filter(filterQuery).select('HID').count('HID').get())][0] as {HID_count:number};
    if(countResult?.HID_count && countResult.HID_count>0){
      if(countResult.HID_count>5000){
        let batchIndex=0;
        const pageSize=5000;
        let fetchedCount=0;
        while(fetchedCount < countResult.HID_count){
          const items = await query
            .select(...historyFields)
            .top(pageSize)
            .skip(batchIndex*pageSize)
            .get();
          allItems = [...allItems, ...items];
          fetchedCount += [...items].length;
          batchIndex++;
        }
      }
      else{
        allItems = [...(await query.select(...historyFields).get())];
      }
    }
    return allItems;
    
  } catch (error) {
    console.error("Error fetching inquiries:", error);
    throw error;
  }
  
  
};

export const fetchAllExportViewInquiries = async (
  filterQuery: string = "",
  selectColumns:string[]
) => {
  try {
    let allItems: any[] = [];

const viewsData = await anewRViewsHttp().getview(viewNameForExport);

    let query = viewsData.query();
    const queryStr = (filterQuery ?? '').replaceAll(InquiryViewColumns.ItemCreated,InquiryViewColumns.SubmittedDate)
    if (queryStr) {
      query = query.filter(`${queryStr}`);
    }

    const countResult = [...(await viewsData.query().filter(queryStr).select(InquiryViewColumns.InquiryGUID).count(InquiryViewColumns.InquiryGUID).distinct(true).get())][0] as {InquiryGUID_count:number};
    if(countResult?.InquiryGUID_count && countResult.InquiryGUID_count>0){
      if(countResult.InquiryGUID_count>5000){
        let batchIndex=0;
        const pageSize=5000;
        let fetchedCount=0;
        while(fetchedCount < countResult.InquiryGUID_count){
          const items = await query
            .select(...selectColumns)
            .orderBy([{ orderBy: "ItemModified", ascending: false }])
            .top(pageSize)
            .skip(batchIndex*pageSize)
            .distinct(true)
            .get();
          allItems = [...allItems, ...items];
          fetchedCount += [...items].length;
          batchIndex++;
        }
      }
      else{
        allItems = [...(await query.select(...selectColumns).distinct(true).get())];
      }
    }
    return allItems;
    
  } catch (error) {
    console.error("Error fetching inquiries:", error);
    throw error;
  }
  
  
};